import { RecommendationSource } from '@/enums/recommendation'
import { RecommendationProduct } from '../components/Products/Products'

export const useRecommendationCustomization = ({
  recommendationSource,
  recommendationProducts,
  isLocked = false,
}: {
  recommendationSource: RecommendationSource
  recommendationProducts?: RecommendationProduct[]
  isLocked?: boolean
}) => {
  const isPriceModifiedByAdmin = recommendationProducts?.some(
    (product) => product.isSearchEnginePrice === false,
  )
  const isOptimizationImplementedInModule =
    recommendationSource !== RecommendationSource.Public
  const shouldShowRecommendationCustomization =
    isOptimizationImplementedInModule && !isPriceModifiedByAdmin && !isLocked

  return {
    shouldShowRecommendationCustomization,
  }
}
